import * as type from '../types/uiTypes';
const initialState = {
    pen_id : null,
    pen_loading : true,
    save_btn_text : "Save",
    fork_btn_text : "Fork",
    show_popup : false
}
const counterReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.SET_PEN_ID:
            return {...state, pen_id: action.payload};
        case type.SET_PEN_LOADING:
            return {...state, pen_loading : action.payload}
        case type.SET_SAVE_BTN_TXT:
            return {...state, save_btn_text : action.payload}
        case type.SET_FORK_BTN_TXT:
            return {...state, fork_btn_text : action.payload}
        case type.SET_POPUP:
            return {...state, show_popup : action.payload}
        default:
            return {...state};
    }
};

export default counterReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/uiReducer.js